import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_holidays_seasonal: FaireCategoryEntity = {
  token: "cat_holidays-seasonal",
  type: "category",
  name: "Holidays & seasonal",
  level: 1,
  href: "/category/holidays-seasonal",
  childCategoryTokens: [
    "cat_holidays-all",
    "cat_holidays-new-products",
    "cat_holidays-new-brands",
    "cat_holidays-bestsellers",
    "cat_holidays-upcoming",
    "cat_holidays-valentines",
    "cat_holidays-spring",
    "cat_holidays-summer",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
